import React, { Component } from 'react';
import { useState, useEffect } from 'react';
import { CmtyBaseTable } from '../CmtyBaseTable';
import { CTMY_CATG_HOUSE, CTMY_CATG_HOUSE_NAME, CTMY_CATG_HOUSE_URL, CTMY_CATG_HOUSE_URL_NAME } from '../CmtyConstant'

export function CmtyHouse() {
    useEffect(() => {
        localStorage.setItem("CTMY_CATG", CTMY_CATG_HOUSE)
        localStorage.setItem("CTMY_CATG_URL", CTMY_CATG_HOUSE_URL)
        localStorage.setItem("CTMY_CATG_NAME", CTMY_CATG_HOUSE_NAME)
    }, []);

    return (
        <div>
            <main class="page lanidng-page">
                <section>
                    <div class="container" style={{paddingTop:'100px', marginTop: '10px', marginBottom: '10px'}}>
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><span>커뮤니티</span></li>
                            <li class="breadcrumb-item"><span>집</span></li>
                        </ol>
                    </div>
                    <div class="container">
                        <CmtyBaseTable cmtyCatg={CTMY_CATG_HOUSE} cmtyCatgName={CTMY_CATG_HOUSE_NAME} 
                            cmtyCatgUrl={CTMY_CATG_HOUSE_URL} cmtyCatgUrlName={CTMY_CATG_HOUSE_URL_NAME}/>
                    </div>
                </section>
            </main>
        </div>
    );
}